// extracted by mini-css-extract-plugin
module.exports = {"button":"MapButtonClose_button__5tnM_"};